import LoadingCircle from '~components/Loading';
import { COMPANY_DETAIL_MENU } from '~constant/company';
import Card from '~features/company/Card';
import useGetCompanySummary from '~hooks/query/company/useCompanySummary';
import { useRouterQuery } from '~hooks/useRouterQuery';
import { ValueOf } from '~types/common';
import { CompanyStates } from '~types/company';

import ErrorSection from '../ErrorSection';
import ClosedContent from './ClosedContent';
import DeletedContent from './DeletedContent';
import EmployeeCard from './EmployeeCard';
import SalaryCard from './SalaryCard';
import SalesCard from './SalesCard';
import { CompanySummaryWrapper } from './style';

function SummaryInfo({
  registerRef,
  companyStates,
}: {
  registerRef: (element: HTMLElement, id: ValueOf<typeof COMPANY_DETAIL_MENU>) => void;
  companyStates: CompanyStates;
}) {
  const companyId = useRouterQuery('companyId');
  const { data, status } = useGetCompanySummary(companyId);

  const cardProps = {
    title: '기업 요약',
    registerRef,
    sectionId: COMPANY_DETAIL_MENU.COMPANY_SUMMARY,
  };

  if (status === 'error') {
    return (
      <Card {...cardProps}>
        <ErrorSection />
      </Card>
    );
  }

  if (status === 'loading') {
    return (
      <Card {...cardProps}>
        <LoadingCircle />
      </Card>
    );
  }
  if (companyStates.deleted) {
    return (
      <Card {...cardProps}>
        <DeletedContent />
      </Card>
    );
  }

  if (companyStates.closed) {
    return (
      <Card {...cardProps}>
        <ClosedContent closedDate={companyStates.closedAt} />
      </Card>
    );
  }

  return (
    <Card {...cardProps}>
      <CompanySummaryWrapper>
        <SalaryCard salary={data.salary} companyStates={companyStates} />
        <EmployeeCard employee={data.employee} companyStates={companyStates} />
        <SalesCard sales={data.sales} companyStates={companyStates} />
      </CompanySummaryWrapper>
    </Card>
  );
}

export default SummaryInfo;
